import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco1 from "./assets/img/PlaneIco-1.png";
import captchaCode from "./assets/img/captchaCode.png";
import captchaImg from "./assets/img/captchaImg.png";
import saleImg from "./assets/img/saleImg.png";
import QRImg from "./assets/img/QRImg.png";
import giftImg from "./assets/img/giftImg.png";
import ErrorImg from "./assets/img/ErrorImg.png";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {
  saveFlightBooking,
  makePaymentSession,
  createFlightBooking,
  directFlightBooking,
  validateOTP,
  sendOTP,
  confirmationEmail,
  convertCurrency,
  changeRequest,
} from "../services/services";
import arrowWhiteIco from "./assets/img/arrowWhiteIco.png";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { MAKE_PAYMENT_SESSION, VERIFY_PAYMENT } from "../utils/constantAPI";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { formatDateWithWeekday } from "./formatDateWithWeekday";
import { toast } from "react-toastify";
import { countryList, toastCSS } from "../services/commonHandler";

const FlightReservationTwo = () => {
  const navigate = useNavigate();

  const [passengerType, setPassengerType] = useState("ADT");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationality, setNantionality] = useState("US");
  const [phoneCountryCode, setPhoneCountryCode] = useState("+1");
  const [altPhoneCountryCode, setAltPhoneCountryCode] = useState("+1");
  const [gender, setGender] = useState("Male");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [passportExpDate, setPassportExpDate] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isOpen, setIsOpen] = useState(true); // Default to open
  const [contactEmail, setContactEmail] = useState("");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [mainContactNumber, setMainContactNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [showEmailError, setShowEmailError] = useState(false);
  const [showFirstNameError, setShowFirstNameError] = useState(false);
  const [showLastNameError, setShowLastNameError] = useState(false);
  const [showPassportExpDateError, setShowPassportExpDateError] =
    useState(false);
  const [showDateOfBirthError, setShowDateOfBirthError] = useState(false);
  const [showPassportNumberError, setShowPassportNumberError] = useState(false);
  const [showPhoneNumberError, setShowPhoneNumberError] = useState(false);
  const [showContactEmailError, setShowContactEmailError] = useState(false);
  const [showVerifyEmailError, setShowVerifyEmailError] = useState(false);
  const [showMainContactNumberError, setShowMainContactNumberError] =
    useState(false);
  const [noExpiration, setNoExpiration] = useState(false);
  const [convertedPrice, setConvertedPrice] = useState(null);
  const [showMobileNumberError, setShowMobileNumberError] = useState(false);
  const [passengers, setPassengers] = useState([
    {
      passengerType: "ADT",
      firstName: "",
      lastName: "",
      nationality: "US",
      gender: "Male",
      dateOfBirth: "",
      passportNumber: "",
      passportExpDate: "",
      phoneNumber: "",
      email: "",
      useContactEmail: false,
      useContactPhone: false,
      preferences: {
        assistance: "No Preference",
        seatPreference: "No Preference",
        frequentFlyerNumber: "",
      },
      meal: {
        code: "No Preference",
        description: "No Preference",
      },
      extraBaggage: {
        code: "",
        description: "",
      },
    },
  ]);

  const [isEditing, setIsEditing] = useState(false);
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 0,
    children: 0,
    infants: 0,
  });
  const [airports, setAirports] = useState([]);
  const [flightSearchData, setFlightSearchData] = useState(null);
  const [detailFlightSearchData, setDetailFlightSearchData] = useState(null);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isValidated, setIsValidated] = useState(false);

  const location = useLocation();
  const {
    ItemCodeRef,
    SegmentCodeRefs,
    UniqueTransID,
    PriceCodeRef,
    Currency,
    TotalPrice,
  } = location.state || {};

  const [preferredCurrency, setPreferredCurrency] = useState(
    localStorage.getItem("preferredCurrency") || Currency || "MYR"
  );
  const [convertedTotalPrice, setConvertedTotalPrice] = useState(TotalPrice);

  useEffect(() => {
    setPassengers(
      passengers.map((p) => ({
        ...p,
        email: p.useContactEmail ? verifyEmail : p.email,
        phoneNumber: p.useContactPhone ? mainContactNumber : p.phoneNumber,
      }))
    );
  }, [verifyEmail, mainContactNumber]);
  useEffect(() => {
    if (isValidated) {
      setPassengers(
        passengers.map((p) => ({
          ...p,
          email: p.useContactEmail ? verifyEmail : p.email,
          phoneNumber: p.useContactPhone ? mainContactNumber : p.phoneNumber,
        }))
      );
    }
  }, [verifyEmail, mainContactNumber, isValidated]);

  //const { passengerCounts = {} } = location.state || {};
  const totalPassengerCount =
    passengerCounts.adults + passengerCounts.children + passengerCounts.infants;

  useEffect(() => {
    const storedData = localStorage.getItem("flightSearchData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setFlightSearchData(parsedData);
      const {
        fromLocation,
        toLocation,
        departureDate,
        returnDate,
        passengerCounts,
        seatClass,
      } = JSON.parse(storedData);
      if (passengerCounts) setPassengerCounts(passengerCounts);
    }
  }, []);
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const detailFlightData = localStorage.getItem("DetailflightSearchData");
  function getPassengerTitle(passengerType, gender) {
    if (passengerType === "ADT") {
      return gender === "Male" ? "Mr" : "Ms";
    }
    if (passengerType === "CNN" || passengerType === "INF") {
      return gender === "Male" ? "MSTR" : "Miss";
    }
    return "Mr"; // default fallback
  }

  useEffect(() => {
    const types = [];

    for (let i = 0; i < passengerCounts.adults; i++) types.push("ADT");
    for (let i = 0; i < passengerCounts.children; i++) types.push("CNN");
    for (let i = 0; i < passengerCounts.infants; i++) types.push("INF");

    const generated = types.map((type) => ({
      passengerType: type,
      title: "",
      firstName: "",
      lastName: "",
      nationality: "US",
      gender: "Male",
      dateOfBirth: "",
      passportNumber: "",
      passportExpDate: "",
      email: "",
      phone: "",
      useContactEmail: false,
      useContactPhone: false,
      preferences: {
        assistance: "No Preference",
        seatPreference: "No Preference",
        frequentFlyerNumber: "",
      },
      meal: {
        code: "No Preference",
        description: "No Preference",
      },
      extraBaggage: {
        code: "",
        description: "",
      },
    }));

    setPassengers(generated);
  }, [passengerCounts]);

  const dobRefs = useRef([]);
  const expRefs = useRef([]);
  useEffect(() => {
    setIsOtpSent(false);
    setIsValidated(false);
    setOtp("");
    setCountdown(0);
    setErrors({});
  }, [emailOrPhone]);

  useEffect(() => {
    // Initialize Flatpickr
    const datePicker = flatpickr("#datepicker", {
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
      onChange: (selectedDates, dateStr) => {
        // Update the React state with the selected date
        setDateOfBirth(dateStr);
      },
    });

    const passportExpPicker = flatpickr("#passportExpDate", {
      dateFormat: "Y-m-d",
      allowInput: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
      onChange: (selectedDates, dateStr) => {
        // Update the React state with the selected date for Passport Expiry Date
        setPassportExpDate(dateStr);
      },
    });

    // Add event listener for the button
    const button = document.getElementById("addPassengerButton");
    const formDiv = document.querySelector(".addPassengerContentWrap");

    if (button && formDiv) {
      button.addEventListener("click", () => {
        formDiv.style.display = "block";
      });
    }

    // Cleanup function to remove event listener
    return () => {
      if (button) {
        button.removeEventListener("click", () => {
          formDiv.style.display = "block";
        });
      }
    };
  }, []); // Run only once when the component mounts

  const parsedFlightData = JSON.parse(detailFlightData);
  useEffect(() => {
    passengers.forEach((_, index) => {
      const dobInput = dobRefs.current[index];
      const expInput = expRefs.current[index];

      if (dobInput) {
        flatpickr(dobInput, {
          dateFormat: "Y-m-d",
          defaultDate: passengers[index].dateOfBirth || null,
          onChange: (selectedDates, dateStr) => {
            const updated = [...passengers];
            updated[index].dateOfBirth = dateStr;
            setPassengers(updated);
          },
        });
      }

      if (expInput) {
        flatpickr(expInput, {
          dateFormat: "Y-m-d",
          defaultDate: passengers[index].passportExpDate || null,
          onChange: (selectedDates, dateStr) => {
            const updated = [...passengers];
            updated[index].passportExpDate = dateStr;
            setPassengers(updated);
          },
        });
      }
    });
  }, [passengers]);
  //   if (response?.error?.code === 400 || response?.code === 400 ) {
  //     if(response?.message === 'Insufficient Balance' || response?.error?.code === 400){
  //   if (response?.message === 'Insufficient Balance') {

  //   const flightBookingData = JSON.parse(localStorage.getItem("flightBookingData"))
  //   const parseSerchData =JSON.parse(flightBookingData.searchData)
  //   const email=flightBookingData?.contactInfo?.email
  //   const phone=flightBookingData?.contactInfo?.phoneCountryCode+flightBookingData?.contactInfo?.phone
  //   const passengerName = `${flightBookingData?.passengerDetails[0]?.firstName || ''} ${flightBookingData?.passengerDetails[0]?.lastName || ''}`.trim();
  //   const bookingRef=flightBookingData?.flightBooking?.uniqueTransId

  //   const destination=parseSerchData.Directions?.[0]?.[0]?.DestinationName
  //   const departureDateTime = parseSerchData?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure;
  //   const date = departureDateTime?.split(" ")[0];
  //   const time = departureDateTime?.split(" ")[1];

  //   const fallbackBookingData = {
  //     BookingTransactionRef: bookingRef,
  //     BookingStatus: "BOOKED",
  //   };
  //   const emailData = {
  //     email: email,
  //     phone: phone,
  //     passengerName: passengerName,
  //     bookingRef: bookingRef,
  //     destination: destination,
  //     date: date,
  //     time: time,
  //   };

  //   await confirmationEmail(
  //     emailData,
  //     () => console.log("Fallback email sent for insufficient balance"),
  //     (error) => console.error("Failed to send fallback email:", error)
  //   );

  //   navigate("/BookingConfirmation", {
  //     state: { bookingData: fallbackBookingData },
  //   });
  //   return;
  // } else {
  //   navigate('/ErrorPage', {
  //     state: {
  //       errorMessage: response.error?.message || response?.message || "Something went wrong with flight booking.",
  //     },
  //   });
  //   return;
  // }
  //     }else
  //     navigate('/ErrorPage',{state:{errorMessage: response.error?.message ||response?.message || "Something went wrong with flight booking."}});
  //     // toast.error(
  //     //   response.error?.message || "Something went wrong with",
  //     //   toastCSS
  //     // );
  //     return;
  //   }

  //   const bookingData = response.booking.data;

  //   const passenger = bookingData?.TicketInfoes?.[0]?.PassengerInfo;
  //   const contact = passenger?.ContactInfo;
  //   const name = `${passenger?.NameElement?.FirstName} ${passenger?.NameElement?.LastName}`;
  //   const destination =
  //     bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Destination;
  //   const travelDate =
  //     bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(
  //       " "
  //     )[0];
  //   const time =
  //     bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(
  //       " "
  //     )[1];

  //   const emailData = {
  //     email: contact?.Email,
  //     // phone: bookingData.contactInfo.phoneCountryCode+" "+ bookingData.contactInfo.phone,
  //     phone: contact?.PhoneCountryCode+contact?.Phone,
  //     passengerName: name,
  //     bookingRef: bookingData?.uniqueTransId,
  //     destination,
  //     date: travelDate,
  //     time,
  //   };

  //   // Use the confirmationEmail service
  //   await confirmationEmail(
  //     emailData,
  //     (emailResponse) => {
  //       console.log("Initial email sent successfully:", emailResponse);
  //       console.log("Flight Booking Successful:", response);
  //       navigate("/BookingConfirmation", {
  //         state: { bookingData: bookingData },
  //       });
  //     },
  //     (error) => {
  //       console.error("Failed to send initial email:", error);
  //       // Still proceed to navigate even if email fails
  //       navigate("/BookingConfirmation", {
  //         state: { bookingData: bookingData },
  //       });
  //     }
  //   );
  // };
  const onSuccess = async (response) => {
    const hasAdditionalBaggage =
      localStorage.getItem("requestAdditionalBaggage") === "true";

    if (response?.error?.code === 400 || response?.code === 400) {
      if (response?.message === "Insufficient Balance") {
        const flightBookingData = JSON.parse(
          localStorage.getItem("flightBookingData")
        );
        const parseSerchData = JSON.parse(flightBookingData.searchData);
        const email = flightBookingData?.contactInfo?.email;
        const phone =
          flightBookingData?.contactInfo?.phoneCountryCode +
          flightBookingData?.contactInfo?.phone;
        const passengerName = `${
          flightBookingData?.passengerDetails[0]?.firstName || ""
        } ${flightBookingData?.passengerDetails[0]?.lastName || ""}`.trim();
        const bookingRef = flightBookingData?.flightBooking?.uniqueTransId;

        const destination =
          parseSerchData.Directions?.[0]?.[0]?.DestinationName;
        const departureDateTime =
          parseSerchData?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure;
        const date = departureDateTime?.split(" ")[0];
        const time = departureDateTime?.split(" ")[1];

        const fallbackBookingData = {
          BookingTransactionRef: bookingRef,
          BookingStatus: "BOOKED",
        };

        const emailData = {
          email: email,
          phone: phone,
          passengerName: passengerName,
          bookingRef: bookingRef,
          destination: destination,
          date: date,
          time: time,
          additionalBaggage: hasAdditionalBaggage,
        };

        if (hasAdditionalBaggage) {
          try {
            const bookingId = localStorage.getItem("bookingId");
            if (bookingId) {
              await changeRequest(
                {
                  bookingId,
                  reasonType: ["Additional Baggage"],
                  details: "Automatic baggage request from booking",
                },
                () => console.log("Fallback baggage request created"),
                (error) =>
                  console.error(
                    "Failed to create fallback baggage request:",
                    error
                  )
              );
            }
          } catch (error) {
            console.error("Error creating fallback baggage request:", error);
          }
        }
        localStorage.removeItem("bookingId");
        await confirmationEmail(
          emailData,
          () => {
            console.log("Fallback email sent for insufficient balance");
            localStorage.removeItem("requestAdditionalBaggage"); // Cleanup
          },
          (error) => {
            console.error("Failed to send fallback email:", error);
            localStorage.removeItem("requestAdditionalBaggage"); // Cleanup
          }
        );

        navigate("/BookingConfirmation", {
          state: { bookingData: fallbackBookingData },
        });
        return;
      } else {
        localStorage.removeItem("requestAdditionalBaggage"); // Cleanup even on error
        navigate("/ErrorPage", {
          state: {
            errorMessage:
              response.error?.message ||
              response?.message ||
              "Something went wrong with flight booking.",
          },
        });
        return;
      }
    }

    // Handle successful booking
    const bookingData = response.booking.data;
    const passenger = bookingData?.TicketInfoes?.[0]?.PassengerInfo;
    const contact = passenger?.ContactInfo;
    const name = `${passenger?.NameElement?.FirstName} ${passenger?.NameElement?.LastName}`;
    const destination =
      bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Destination;
    const travelDate =
      bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(
        " "
      )[0];
    const time =
      bookingData?.FlightInfo?.Directions?.[0]?.[0]?.Segments?.[0]?.Departure?.split(
        " "
      )[1];

    // Create baggage request if needed
    if (hasAdditionalBaggage) {
      try {
        const bookingId = localStorage.getItem("bookingId");
        if (bookingId) {
          await changeRequest(
            {
              bookingId,
              reasonType: ["Additional Baggage"],
              details: "Automatic baggage request from booking",
            },
            () => console.log("Baggage request created successfully"),
            (error) => console.error("Failed to create baggage request:", error)
          );
        }
      } catch (error) {
        console.error("Error creating baggage request:", error);
      }
    }
    localStorage.removeItem("bookingId");
    // Prepare email data
    const emailData = {
      email: contact?.Email,
      phone: contact?.PhoneCountryCode + contact?.Phone,
      passengerName: name,
      bookingRef:
        bookingData?.uniqueTransId || bookingData?.BookingTransactionRef,
      destination,
      date: travelDate,
      time,
      additionalBaggage: hasAdditionalBaggage,
    };

    // Send confirmation email
    await confirmationEmail(
      emailData,
      (emailResponse) => {
        console.log("Initial email sent successfully:", emailResponse);
        localStorage.removeItem("requestAdditionalBaggage"); // Cleanup
        navigate("/BookingConfirmation", {
          state: { bookingData: bookingData },
        });
      },
      (error) => {
        console.error("Failed to send initial email:", error);
        localStorage.removeItem("requestAdditionalBaggage"); // Cleanup
        navigate("/BookingConfirmation", {
          state: { bookingData: bookingData },
        });
      }
    );
  };
  const onError = (error) => {
    console.log(error);
  };
  const handleSendOTP = async () => {
    setErrors({});
    if (!emailOrPhone) {
      setErrors({ emailOrPhone: "Email is required" });
      return;
    }
    setIsValidating(true);
    try {
      await sendOTP(
        { email: emailOrPhone },
        (res) => {
          setIsOtpSent(true);
          setCountdown(60); // 60 seconds cooldown
        },
        (err) => {
          setErrors({
            emailOrPhone: err.response?.data?.error || "Failed to send OTP",
          });
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsValidating(false);
    }
  };
  const handleValidateOTP = async () => {
    setErrors({});
    if (!otp) {
      setErrors({ otp: "OTP is required" });
      return;
    }

    try {
      await validateOTP(
        { email: emailOrPhone, otp },
        (res) => {
          toast.success("OTP validated successfully!", toastCSS);
          setIsValidated(true);
          setIsEmailVerified(true);
          setIsEditing(false);
          setContactEmail(emailOrPhone);
          setVerifyEmail(emailOrPhone);
          setCountdown(0);
          setIsOtpSent(false);
        },
        (err) => {
          setErrors({ otp: err.response?.data?.error || "Invalid OTP" });
        }
      );
    } catch (error) {
      console.error(error);
    }
  };
  //  const handleEdit = () => {
  //   setIsEditing(true);
  //   setIsValidated(false);
  // };
  function formatDate(inputDate) {
    if (!inputDate) return null;

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return null;

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${mm}-${dd}-${yyyy}`;
  }

  function formatDatePayload(inputDate) {
    if (!inputDate) return null;

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) return null;

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${yyyy}-${mm}-${dd}`;
  }
  const finalizeFlightBooking = async (bookingData) => {
    if (!bookingData) {
      console.error("No booking data provided!");
      return;
    }

    let formattedData = {
      PassengerInfoes: bookingData.passengerDetails.map((passenger) => ({
        PassengerType: passenger.passengerType,
        Title: getPassengerTitle(passenger.passengerType, passenger.gender),
        FirstName: passenger.firstName,
        LastName: passenger.lastName,
        Gender: passenger.gender,
        DateOfBirth: formatDatePayload(passenger.dateOfBirth),
        PassportNumber: passenger.passportNumber,
        PassportExpireDate: formatDatePayload(passenger.PassportExpireDate),
        Nationality: passenger.nationality,
        IsWheelchair: passenger.isWheelchair,
        IssuingCountry: passenger.issuingCountry,
        PhoneCountryCode: passenger.phoneCountryCode,
        Phone: passenger.phone,
        Email: passenger.email,
      })),
      ContactInfo: {
        Email: bookingData.contactInfo.email,
        Phone: bookingData.contactInfo.phone,
        PhoneCountryCode: bookingData.contactInfo.phoneCountryCode,
      },
      UniqueTransID: bookingData.flightBooking.uniqueTransId,
      ItemCodeRef: bookingData.flightBooking.itemCodeRef,
      PriceCodeRef: bookingData.flightBooking.priceCodeRef,
    };

    // console.log("Sending Flight Booking Data:", formattedData);

    try {
      if (parsedFlightData.Bookable === true) {
        await createFlightBooking(formattedData, onSuccess, onError);
      } else {
        await directFlightBooking(formattedData, onSuccess, onError);
      }
    } catch (error) {
      console.error("Booking Error:", error);
    }
  };

  const verifyPayment = async (sessionId) => {
    try {
      let response = await axios.post(VERIFY_PAYMENT, { sessionId });

      if (response.data.success) {
        console.log("Payment Verified! Proceeding with flight booking...");

        // Retrieve form data from localStorage
        const storedData = localStorage.getItem("flightBookingData");
        if (storedData) {
          finalizeFlightBooking(JSON.parse(storedData));
        }
      } else {
        console.error("Payment verification failed!");
      }
    } catch (error) {
      console.error("Payment verification error:", error);
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    if (sessionId) {
      console.log("Payment Success! Session ID:", sessionId);

      //  Verify payment with backend
      verifyPayment(sessionId);
    }
  }, [location]);

  if (!location.state) {
    return (
      <>
        <Header />
        <div className="errorState">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="imgWrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="140"
                    height="222"
                    viewBox="0 0 140 222"
                    fill="none"
                  >
                    <path
                      d="M78.2832 1.36426V21.5049C95.4636 22.9033 109.134 27.9623 119.236 36.7393C129.47 45.6311 135.152 
                    57.9518 136.319 73.6318L136.37 74.3154H89.7275L89.665 73.749C89.1781 69.3671 87.9044 65.8007 85.876 63.0166C84.0125 60.4589 
81.489 58.5325 78.2832 57.2402V94.2783C91.7896 98.0313 102.243 101.385 109.631 104.34C117.182 107.36 123.88 112.389 129.726 
119.404H129.725C135.801 126.332 138.802 135.836 138.802 147.839C138.802 157.05 136.37 165.596 131.515 173.467L131.516 
173.468C126.817 181.187 119.781 187.544 110.439 192.548L110.436 192.55C101.389 197.32 90.6654 199.972 78.2832 200.531V220.649H61.1377V200.256C43.7826 
198.694 29.7059 193.471 18.9551 184.539L18.9512 184.535C8.05284 175.313 2.28037 162.821 1.6123 147.121L1.58496 146.459H47.9639L48.0215 147.031C48.5088 151.905 
49.9254 155.858 52.2373 158.927C54.3908 161.786 57.3478 163.913 61.1377 165.299V127.496C48.4492 124.229 38.2437 121.038 30.5322 117.921L30.5283 117.919C22.8178 114.734 16.039 109.625 10.1924 102.609C4.2821 95.517 1.36426 85.8478 1.36426 73.6787C1.36436 58.4526 6.98018 46.1973 18.2139 36.9756L18.2178 36.9727C29.4557 27.8832 43.7762 22.7381 61.1377 21.498V1.36426H78.2832ZM78.2832 166.174C82.7723 165.298 86.2732 163.418 88.8311 160.56L88.8369 160.553L88.8428 160.547C91.6989 157.532 93.1328 153.806 93.1328 149.326C93.1327 145.181 91.7849 141.884 89.1172 139.373L89.1025 139.359L89.0898 139.346C86.6763 136.781 83.0885 134.54 78.2832 132.644V166.174ZM61.1377 55.8486C56.9726 56.7126 53.7159 58.4287 51.3242 60.9697L51.3105 60.9834C48.8153 63.4787 47.5283 67.0191 47.5283 71.6953C47.5284 75.6835 48.7183 78.996 51.0762 81.6758L51.5703 82.1846C53.9337 84.5392 57.1158 86.6679 61.1377 88.5605V55.8486Z"
                      stroke="#CF992F"
                      strokeWidth="1.27174"
                    />
                  </svg>
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <div className="topWrap">
                    {/* <h2>Missing Flight Information</h2> */}
                    <p>
                      Please wait while we redirect you to the confirmation
                      page. Kindly avoid using the back button during this
                      process
                    </p>
                    {/* <button
                      className="btn"
                      onClick={() => navigate("/flights")}
                    >
                      Search Flights Again
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const segments = location.state.segments || [];
  const firstSegment = segments[0] || {};

  const PASSPORT_RULES = {
    US: { min: 9, max: 9, pattern: /^[A-Z0-9]{9}$/ },
    IN: { min: 6, max: 9, pattern: /^[A-Z][0-9]{7}$/ },
    UK: { min: 8, max: 10, pattern: /^[A-Z0-9]{8,10}$/ },
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePassport = (passportNumber, nationality) => {
    const countryRules = PASSPORT_RULES[nationality] || PASSPORT_RULES.US;
    return (
      passportNumber &&
      passportNumber.length >= countryRules.min &&
      passportNumber.length <= countryRules.max &&
      countryRules.pattern.test(passportNumber)
    );
  };

  const validateName = (name) => {
    return /^[a-zA-Z\s-]+$/.test(name) && name.length >= 2 && name.length < 25;
  };

  const validatePhoneNumber = (phoneNumber) => {
    return phoneNumber && phoneNumber.replace(/\D/g, "").length >= 8;
  };

  const saveFlightBookingDetails = async () => {
    let isValid = true;

    // Validate contact info (global)
    if (!contactEmail || !validateEmail(contactEmail)) {
      setShowContactEmailError(true);
      isValid = false;
    } else {
      setShowContactEmailError(false);
    }

    if (!verifyEmail || verifyEmail !== contactEmail) {
      setShowVerifyEmailError(true);
      isValid = false;
    } else {
      setShowVerifyEmailError(false);
    }

    if (!mainContactNumber) {
      setShowMainContactNumberError(true);
      isValid = false;
    } else {
      setShowMainContactNumberError(false);
    }

    if (!mobileNumber) {
      setShowMobileNumberError(true);
      isValid = false;
    } else {
      setShowMobileNumberError(false);
    }

    passengers.forEach((p, index) => {
      if (!p.firstName || !validateName(p.firstName)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid first name.`, toastCSS);
      }

      if (!p.lastName || !validateName(p.lastName)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid last name.`, toastCSS);
      }

      if (!p.dateOfBirth) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Date of birth is required.`,
          toastCSS
        );
      }

      if (!p.passportExpDate && !p.noExpiration) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Passport expiration date is required.`,
          toastCSS
        );
      }

      if (
        !p.passportNumber ||
        !validatePassport(p.passportNumber, p.nationality)
      ) {
        isValid = false;
        toast.error(
          `Passenger ${index + 1}: Invalid passport number.`,
          toastCSS
        );
      }

      if (!p.email || !validateEmail(p.email)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid email.`, toastCSS);
      }

      if (!p.phoneNumber || !validatePhoneNumber(p.phoneNumber)) {
        isValid = false;
        toast.error(`Passenger ${index + 1}: Invalid phone number.`, toastCSS);
      }
    });

    if (!isValid) {
      toast.error(`Please fix the errors before proceeding.`, toastCSS);
      return;
    }

    console.log("Validation passed! Proceeding to payment...");

    await makePayment(parseFloat(TotalPrice), Currency);
  };
  const handleNoExpirationChange = (e) => {
    const isChecked = e.target.checked;
    setNoExpiration(isChecked);
    if (isChecked) {
      setPassportExpDate("");
    }
  };

  const makePayment = async (amount, currency) => {
    const stripe = await loadStripe(
      //live changes needed
      // "pk_test_51OtYpRSAz7hIGu737oR8mSEZHpvkxdvQo199p6lE5TBujOtXftc5aq68prIJXGMz8hbAkVYKrgvHyVHsyN23FEXb00qFZfKq5n"
      "pk_live_51N8QFdISzdvlhh7Qhw6y0EHx4ZCqduupbd1iohAb78dayk1Ceq3Q2Vkucv17BJJZUu4Km117eqeUBQyicOzpFlvW00AfDlv1Rn"
    );
    let flightBookingData = {
      uniqueTransId: UniqueTransID,
      itemCodeRef: ItemCodeRef,
      priceCodeRef: PriceCodeRef,
      totalAmount: amount,
      currency: Currency,
      bookingDate: new Date().toISOString().split("T")[0],
    };

    let contactInfo = {
      email: contactEmail,
      phone: mainContactNumber,
      phoneCountryCode: phoneCountryCode,
    };

    let passengersPayload = passengers.map((p) => ({
      passengerType: p.passengerType,
      title: getPassengerTitle(p.passengerType, p.gender),
      firstName: p.firstName,
      lastName: p.lastName,
      gender: p.gender,
      dateOfBirth: formatDate(p.dateOfBirth),
      passportNumber: p.passportNumber,
      PassportExpireDate: formatDate(p.passportExpDate),
      hasNoExpiration: p.noExpiration,
      nationality: p.nationality,
      isWheelchair: false,
      issuingCountry: "US",
      phoneCountryCode: phoneCountryCode,
      phone: p.phoneNumber,
      email: p.email,
      meal: {
        code: p.meal.code,
        description: p.meal.description,
      },
      extraBaggage: {
        code: p.extraBaggage.code,
        description: p.extraBaggage.description,
      },
      preferences: {
        assistance: p.preferences.assistance,
        seatPreference: p.preferences.seatPreference,
        frequentFlyerNumber: p.preferences.frequentFlyerNumber,
      },
    }));

    let finalData = {
      flightBooking: flightBookingData,
      contactInfo: contactInfo,
      passengerDetails: passengersPayload,
      searchData: detailFlightData,
    };

    localStorage.setItem("flightBookingData", JSON.stringify(finalData));
    await saveFlightBooking(
      finalData,
      (response) => {
        const bookingId = response?.bookingId;
        localStorage.setItem("bookingId", bookingId);
        return response;
      },
      (error) => {
        // alert("Error saving flight booking data. Please try again.");
        console.log(error);
        return error;
      }
    );

    let paymentData = [
      {
        totalAmount: amount,
        currency: Currency,
        bookingDate: new Date().toISOString().split("T")[0],
      },
    ];

    try {
      let response = await axios.post(MAKE_PAYMENT_SESSION, paymentData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data && response.data.id) {
        console.log("Payment Session Created:", response.data);

        //  Redirect user to Stripe checkout
        const result = await stripe.redirectToCheckout({
          sessionId: response.data.id,
        });

        if (result.error) {
          console.error("Stripe Checkout Error:", result.error);
        }
      } else {
        console.error("Invalid response from server:", response);
      }
    } catch (error) {
      console.error("Payment Error:", error);
    }
  };

  const getCityByIata = (iataCode) => {
    const airport = airports.find((airport) => airport.iata === iataCode);
    return airport ? airport.city : iataCode;
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  const calculateTotalTravelTime = (segments) => {
    if (!segments || segments.length === 0) return "0h 0m";

    const firstDeparture = new Date(segments[0].Departure);
    const lastArrival = new Date(segments[segments.length - 1].Arrival);

    const totalMs = lastArrival - firstDeparture;
    const hours = Math.floor(totalMs / (1000 * 60 * 60));
    const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}h ${minutes}m`;
  };

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="flightProgressWrap">
          <div className="flightProgressInner">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-6">
                  <ul>
                    <li>
                      <div className="itemWrap completed">
                        <div className="noWrap">
                          <div className="icoWrap">
                            <img
                              src={arrowWhiteIco}
                              className="img-fluid"
                              alt=""
                            />
                            <p>Review Selection</p>
                          </div>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap active">
                        <div className="noWrap">
                          <h2>2</h2>
                          <p>Enter Details</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>3</h2>
                          <p>Make Payment</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>4</h2>
                          <p>Booking Confirmation</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flightReservWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Flight Reservation/Booking Passenger Details</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-9">
                <div className="leftPannelWrap">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="flightReservDeparWrap">
                        <div className="row">
                          <div className="col-md-5 col-sm-5 col-12">
                            <div className="depRetWrap">
                              <h3>Departure</h3>
                              {segments.length > 0 ? (
                                <ul>
                                  {/* First segment departure */}
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap">
                                        <h2>
                                          {segments[0]?.Departure?.split(
                                            " "
                                          )[1].slice(0, 5) || "N/A"}
                                        </h2>
                                        <p>
                                          {segments[0]?.Departure
                                            ? formatDateWithWeekday(
                                                segments[0].Departure
                                              )
                                            : "N/A"}
                                        </p>
                                      </div>
                                      {/* Last segment arrival */}
                                      <div className="boxWrap">
                                        <h2>
                                          {segments[
                                            segments.length - 1
                                          ]?.Arrival?.split(" ")[1].slice(
                                            0,
                                            5
                                          ) || "N/A"}
                                        </h2>
                                        <p>
                                          {segments[segments.length - 1]
                                            ?.Arrival
                                            ? formatDateWithWeekday(
                                                segments[segments.length - 1]
                                                  .Arrival
                                              )
                                            : "N/A"}
                                        </p>
                                      </div>
                                    </div>
                                  </li>

                                  {/* Flight duration and stops */}
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap boxBigWrap">
                                        <p>
                                          {calculateTotalTravelTime(segments)}
                                        </p>
                                        <p className="clrTxt">
                                          {segments.length === 1
                                            ? "Non-stop"
                                            : `${segments.length - 1} stop(s)`}
                                        </p>
                                      </div>
                                    </div>
                                  </li>

                                  {/* Flight route icons */}
                                  <li>
                                    <div className="itemWrap midIcoWrap">
                                      <div className="icoWrap roundIco"></div>
                                      <div className="icoWrap roundIco"></div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="itemWrap">
                                      <div className="boxWrap">
                                        <h2>{segments[0]?.Origin}</h2>
                                        <p>
                                          {getCityByIata(segments[0]?.Origin)}
                                        </p>
                                      </div>
                                      <div className="boxWrap">
                                        <h2>
                                          {
                                            segments[segments.length - 1]
                                              ?.Destination
                                          }
                                        </h2>
                                        <p>
                                          {getCityByIata(
                                            segments[segments.length - 1]
                                              ?.Destination
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </li>
                                  {/* {segments.length > 1 && (
              <li className="connecting-flights">
                <div className="itemWrap">
                  <div className="connecting-info">
                    <p>Connecting via:</p>
                    <ul>
                      {segments.slice(0, -1).map((segment, index) => (
                        <li key={index}>
                          {segment.Destination} ({getCityByIata(segment.Destination)})
                          {index < segments.length - 2 && ', '}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
            )} */}
                                </ul>
                              ) : (
                                <p>No flight segments available</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="passengerDtlsWrap topPassengerDtlsWrap">
                        <div className="validEmailWrap">
                          <h3>Please Validate Your Email</h3>
                        </div>
                        <form onSubmit={(e) => e.preventDefault()}>
                          <div className="row justify-content-between align-items-start">
                            <div className="col-md-6">
                              <ul className="formList">
                                <li className="half">
                                  <div className="inputField">
                                    <label>Enter Email Address</label>
                                    <input
                                      value={emailOrPhone}
                                      onChange={(e) =>
                                        setEmailOrPhone(e.target.value)
                                      }
                                      disabled={isValidated && !isEditing}
                                    />
                                    {errors.emailOrPhone && (
                                      <p className="ErrorMsg">
                                        {errors.emailOrPhone}
                                      </p>
                                    )}
                                    {/* <p className="ErrorMsg">
                                      Invalid email/phone number
                                    </p> */}
                                    <button
                                      type="button"
                                      className={`verifyBtn btn ${
                                        isValidated ? "verified" : ""
                                      } ${!emailOrPhone ? "disabled" : ""}`}
                                      onClick={() => {
                                        if (!isValidated || isEditing) {
                                          handleSendOTP();
                                        }
                                      }}
                                      disabled={
                                        (isValidated && !isEditing) ||
                                        countdown > 0 ||
                                        !emailOrPhone ||
                                        isValidating
                                      }
                                    >
                                      {isValidating ? (
                                        "Validating..."
                                      ) : isValidated ? (
                                        isEditing ? (
                                          "Re-validate"
                                        ) : (
                                          <span className="verified-content">
                                            Verified ✓
                                            {/* <span
                                              className="edit-link"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setIsEditing(true);
                                              }}
                                            >
                                              Edit
                                            </span> */}
                                          </span>
                                        )
                                      ) : countdown > 0 ? (
                                        `Resend in 00:${String(
                                          countdown
                                        ).padStart(2, "0")}`
                                      ) : (
                                        "Validate"
                                      )}
                                    </button>
                                  </div>
                                  {/* <div className="validation-controls">
                            {isValidated && !isEditing && (
                              <button
                                onClick={handleEdit}
                                className="btn btn-link edit-btn"
                              >
                                Edit Email/Phone
                              </button>
                            )}
                          </div> */}
                                </li>
                                {isOtpSent && !isValidated && (
                                  <li className="half">
                                    <div className="inputField">
                                      <label>OTP</label>
                                      <input
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                      />
                                      <div className="BtmWrap">
                                        {errors.otp && (
                                          <p className="ErrorMsg">
                                            {errors.otp}
                                          </p>
                                        )}
                                        <button
                                          type="button"
                                          className="btn"
                                          disabled={countdown > 0}
                                          onClick={handleSendOTP}
                                        >
                                          {/* Resend {countdown > 0 ? `00:${String(countdown).padStart(2, "0")}` : ""} */}
                                        </button>
                                        <button
                                          type="button"
                                          className="verifyBtn btn"
                                          onClick={handleValidateOTP}
                                        >
                                          Verify
                                        </button>
                                      </div>
                                    </div>
                                  </li>
                                )}
                              </ul>
                            </div>
                            <div className="col-md-5">
                              {/* <div className="captchaCodeWrap">
                                <div className="leftWrap">
                                  <img
                                    src={captchaCode}
                                    className="img-fluid"
                                    alt=""
                                  />
                                  <button className="btn">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M17 7.98506C16.7554 6.22528 15.9391 4.59472 14.6766 3.34455C13.4142 2.09439 11.7758 1.29398 10.0137 1.06661C8.25159 0.839245 6.46362 1.19754 4.9252 2.0863C3.38678 2.97507 2.18325 4.34499 1.5 5.98506M1 1.98506V5.98506H5M1 9.98505C1.24456 11.7448 2.06093 13.3754 3.32336 14.6256C4.58579 15.8757 6.22424 16.6761 7.98633 16.9035C9.74841 17.1309 11.5364 16.7726 13.0748 15.8838C14.6132 14.995 15.8168 13.6251 16.5 11.985M17 15.985V11.985H13"
                                        stroke="#354052"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </div>
                                <div className="rightWrap">
                                  <h5>Invalid Captcha</h5>
                                  <p>Enter the characters in the box</p>
                                </div>
                              </div> */}
                              {/* <div className="captchaWrap">
                                <img
                                  src={captchaImg}
                                  className="img-fluid"
                                  alt=""
                                />
                              </div> */}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="passengerDtlsWrap">
                        <div className="topTtlWrap">
                          <h3>Passengers Details</h3>
                        </div>

                        <div
                          className={`flightReservContactDtlWrap ${
                            !isValidated ? "disabled-form" : ""
                          }`}
                        >
                          {!isValidated && (
                            <div className="form-overlay">
                              <p>Please validate your email first</p>
                            </div>
                          )}
                          <div className="contactDtlsWrap">
                            <div className="topFilterWrap">
                              <div className="leftWrap">
                                <h4>Contact Details</h4>
                                <p>
                                  Your ticket & flight information will be sent
                                  here
                                </p>
                              </div>
                              <button
                                className="btn"
                                type="button"
                                onClick={() => {
                                  // setContactEmail('');
                                  //setVerifyEmail('');
                                  setMainContactNumber("");
                                  setMobileNumber("");
                                }}
                              >
                                Clear Details
                              </button>
                            </div>
                            <form>
                              <ul className="formList">
                                <li className="fourth">
                                  <div
                                    className="inputField"
                                    title={
                                      !isValidated
                                        ? "Please validate your email first"
                                        : ""
                                    }
                                  >
                                    <label>Primary Email Address</label>
                                    <input
                                      type="email"
                                      value={verifyEmail}
                                      onChange={(e) =>
                                        setVerifyEmail(e.target.value)
                                      }
                                      placeholder="verified Email Address"
                                      disabled={!isValidated || isEmailVerified}
                                    />
                                    {showContactEmailError && (
                                      <p className="ErrorMsg">
                                        Invalid email (e.g., john@domain.com)
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div
                                    className="inputField"
                                    title={
                                      !isValidated
                                        ? "Please validate your email first"
                                        : ""
                                    }
                                  >
                                    <label>Re-enter Primary Email</label>
                                    <input
                                      type="email"
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (value !== verifyEmail) {
                                          setShowVerifyEmailError(true);
                                        } else {
                                          setShowVerifyEmailError(false);
                                        }
                                      }}
                                      disabled={!isValidated}
                                      placeholder="Re-enter email"
                                    />
                                    {showVerifyEmailError && (
                                      <p className="ErrorMsg">
                                        Emails do not match or are empty
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div
                                    className="inputField"
                                    title={
                                      !isValidated
                                        ? "Please validate your email first"
                                        : ""
                                    }
                                  >
                                    <label> Primary Contact Number</label>
                                    <PhoneInput
                                      country={"us"}
                                      value={mainContactNumber}
                                      onChange={(e, countryData) => {
                                        setMainContactNumber(e);
                                        setPhoneCountryCode(
                                          countryData.dialCode || "+1"
                                        );
                                      }}
                                      disabled={!isValidated}
                                      inputProps={{
                                        required: true,
                                        name: "mainContactNumber",
                                        disabled: !isValidated,
                                      }}
                                    />
                                    {showMainContactNumberError && (
                                      <p className="ErrorMsg">
                                        Please enter a Primary Contact Number
                                      </p>
                                    )}
                                  </div>
                                </li>
                                <li className="fourth">
                                  <div
                                    className="inputField"
                                    title={
                                      !isValidated
                                        ? "Please validate your email first"
                                        : ""
                                    }
                                  >
                                    <label>Alternate Mobile Number</label>
                                    <PhoneInput
                                      country={"us"}
                                      value={mobileNumber}
                                      onChange={(e, countryData) => {
                                        setMobileNumber(e);
                                        setAltPhoneCountryCode(
                                          countryData.dialCode || "+1"
                                        );
                                      }}
                                      inputProps={{
                                        required: true,
                                        name: "mobileNumber",
                                      }}
                                      disabled={!isValidated}
                                    />
                                    {showMobileNumberError && (
                                      <p className="ErrorMsg">
                                        Please enter your mobile number
                                      </p>
                                    )}
                                    <div className="noteWrap">
                                      <p>
                                        We ask for your mobile number so we can
                                        call or text you about changes to your
                                        itinerary, or provide helpful
                                        information about your trip.
                                      </p>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </form>
                          </div>

                          <div id="passengerAccordion">
                            {passengers.map((passenger, index) => (
                              <div className="accordion-item" key={index}>
                                {/* OUTER ACCORDION HEADER */}
                                <h2
                                  className="accordion-header"
                                  id={`heading${index}`}
                                >
                                  <button
                                    className={`accordion-button ${
                                      index === 0 ? "" : "collapsed"
                                    }`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded="false"
                                    aria-controls={`collapse${index}`}
                                    disabled={!isValidated}
                                  >
                                    <div className="topFilterWrap">
                                      <h4>Passenger {index + 1}</h4>
                                      <div className="selectWrap">
                                        <select
                                          value={passengerType}
                                          onChange={(e) =>
                                            setPassengerType(e.target.value)
                                          }
                                        >
                                          <option value="ADT">
                                            Adult (over 12 years)
                                          </option>
                                          <option value="CHILD">
                                            Children (below 12 years)
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </button>
                                </h2>

                                <div
                                  id={`collapse${index}`}
                                  className={`accordion-collapse collapse ${
                                    index === 0 ? "show" : ""
                                  }`}
                                  aria-labelledby={`heading${index}`}
                                  data-bs-parent="#passengerAccordion"
                                >
                                  <div className="accordion-body">
                                    <div className="topInfoWrap">
                                      <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.2038 7.81884V11.7658M11.2038 14.726V14.7358M20.0844 10.779C20.0844 15.6837 16.1085 19.6596 11.2038 19.6596C6.29922 19.6596 2.32324 15.6837 2.32324 10.779C2.32324 5.87442 6.29922 1.89844 11.2038 1.89844C16.1085 1.89844 20.0844 5.87442 20.0844 10.779Z"
                                          stroke="#228BE6"
                                          strokeWidth="2.9602"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <p>
                                        Use all given names and surnames{" "}
                                        <span>
                                          exactly as they appear in your
                                          passport/ID
                                        </span>{" "}
                                        to avoid boarding complications.
                                      </p>
                                    </div>
                                    <form>
                                      <ul className="formList">
                                        <li className="third">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>First and Middle Name</label>
                                            <input
                                              disabled={!isValidated}
                                              placeholder="e.g. John Doe"
                                              value={passenger.firstName}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value = e.target.value;
                                                if (
                                                  /^[a-zA-Z\s-]*$/.test(
                                                    value
                                                  ) &&
                                                  value.length <= 25
                                                ) {
                                                  updated[index].firstName =
                                                    value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                              maxLength={25}
                                            />
                                            {showFirstNameError && (
                                              <p className="ErrorMsg">
                                                Please enter a valid first name
                                                (2-25 characters)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>Surname</label>
                                            <input
                                              disabled={!isValidated}
                                              placeholder="e.g. Bobby"
                                              value={passenger.lastName}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value = e.target.value;
                                                if (
                                                  /^[a-zA-Z\s-]*$/.test(
                                                    value
                                                  ) &&
                                                  value.length <= 25
                                                ) {
                                                  updated[index].lastName =
                                                    value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                              maxLength={25}
                                            />
                                            {showLastNameError && (
                                              <p className="ErrorMsg">
                                                Please enter your surname (2-25
                                                characters)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third pad0">
                                          <ul className="subFrmList">
                                            <li className="half">
                                              <div className="inputField">
                                                <label>Nationality</label>
                                                <div className="selectWrap">
                                                  <select
                                                    value={
                                                      passenger.nationality
                                                    }
                                                    onChange={(e) => {
                                                      const updated = [
                                                        ...passengers,
                                                      ];
                                                      updated[
                                                        index
                                                      ].nationality =
                                                        e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                  >
                                                    {countryList.map(
                                                      (val, index) => (
                                                        <option
                                                          key={index}
                                                          value={val.code}
                                                        >
                                                          {val.name}
                                                        </option>
                                                      )
                                                    )}
                                                    {/* <option>US</option>
                                                      <option>Indian</option> */}
                                                  </select>
                                                </div>
                                              </div>
                                            </li>
                                            <li className="half">
                                              <div className="inputField">
                                                <label>Gender</label>
                                                <div className="selectWrap">
                                                  <select
                                                    value={passenger.gender}
                                                    onChange={(e) => {
                                                      const updated = [
                                                        ...passengers,
                                                      ];
                                                      updated[index].gender =
                                                        e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                  >
                                                    <option>Male</option>
                                                    <option>Female</option>
                                                  </select>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </li>
                                        <li className="third">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>Date of birth</label>
                                            <div className="datePickerWrap">
                                              <input
                                                disabled={!isValidated}
                                                placeholder="dd/mm/yyyy"
                                                //id="datepicker"
                                                ref={(el) =>
                                                  (dobRefs.current[index] = el)
                                                }
                                                type="text"
                                                value={passenger.dateOfBirth}
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[index].dateOfBirth =
                                                    e.target.value;
                                                  setPassengers(updated);
                                                }}
                                              />
                                            </div>
                                            {showDateOfBirthError && (
                                              <p className="ErrorMsg">
                                                Please enter your date of birth
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>Passport Number</label>
                                            <input
                                              disabled={!isValidated}
                                              placeholder="Passport number..."
                                              value={passenger.passportNumber}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                const value =
                                                  e.target.value.toUpperCase();
                                                const countryRules =
                                                  PASSPORT_RULES[
                                                    passenger.nationality
                                                  ] || PASSPORT_RULES.US;
                                                if (
                                                  /^[A-Z0-9]*$/.test(value) &&
                                                  value.length <=
                                                    countryRules.max
                                                ) {
                                                  updated[
                                                    index
                                                  ].passportNumber = value;
                                                  setPassengers(updated);
                                                }
                                              }}
                                            />
                                            {showPassportNumberError && (
                                              <p className="ErrorMsg">
                                                {/* Error message as before */}
                                              </p>
                                            )}
                                          </div>
                                        </li>

                                        <li className="third noExpirationWrap">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>
                                              Passport Expiration Date
                                            </label>
                                            <div className="datePickerWrap">
                                              <input
                                                placeholder="dd/mm/yyyy"
                                                //id="passportExpDate"
                                                ref={(el) =>
                                                  (expRefs.current[index] = el)
                                                }
                                                type="text"
                                                value={
                                                  passenger.passportExpDate
                                                }
                                                // onChange={(e) => setPassportExpDate(e.target.value)}
                                                // onChange={(e) => {
                                                //   const updated = [...passengers];
                                                //   updated[index].passportExpDate = e.target.value;
                                                //   setPassengers(updated);
                                                // }}
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[
                                                    index
                                                  ].passportExpDate =
                                                    e.target.value;
                                                  setPassengers(updated);
                                                }}
                                                disabled={
                                                  passenger.noExpiration
                                                }
                                              />
                                            </div>
                                            {showPassportExpDateError && (
                                              <p className="ErrorMsg">
                                                Please enter passport expiration
                                                date
                                              </p>
                                            )}
                                            {/* <div className="checkBoxWrap">
                                                <input
                                                  type="checkbox"
                                                  id="NoExpiration"
                                                  checked={
                                                    passenger.noExpiration
                                                  }
                                                  onChange={
                                                    handleNoExpirationChange
                                                  }
                                                  // onChange={() => {
                                                  //   const updated = [...passengers];
                                                  //   updated[index].noExpiration = !updated[index].noExpiration;
                                                  //   setPassengers(updated);
                                                  // }}
                                                />
                                                <label htmlFor="NoExpiration">
                                                  No expiration
                                                </label>
                                              </div> */}
                                          </div>
                                        </li>

                                        <li className="third marTTop">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>Email Address</label>
                                            <input
                                              disabled={!isValidated}
                                              value={passenger.email}
                                              onChange={(e) => {
                                                const updated = [...passengers];
                                                updated[index].email =
                                                  e.target.value;
                                                setPassengers(updated);
                                              }}
                                            />
                                            <div className="checkbox-wrapper">
                                              <input
                                                type="checkbox"
                                                id={`useContactEmail-${index}`}
                                                checked={
                                                  passenger.useContactEmail
                                                }
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[
                                                    index
                                                  ].useContactEmail =
                                                    e.target.checked;
                                                  if (e.target.checked) {
                                                    updated[index].email =
                                                      verifyEmail;
                                                  }
                                                  setPassengers(updated);
                                                }}
                                              />
                                              <label
                                                htmlFor={`useContactEmail-${index}`}
                                              >
                                                Use primary email
                                              </label>
                                            </div>
                                            {showEmailError && (
                                              <p className="ErrorMsg">
                                                Invalid email (e.g.,
                                                john@domain.com)
                                              </p>
                                            )}
                                          </div>
                                        </li>
                                        <li className="third marTTop">
                                          <div
                                            className="inputField"
                                            title={
                                              !isValidated
                                                ? "Please validate your email first"
                                                : ""
                                            }
                                          >
                                            <label>Mobile Number</label>
                                            <PhoneInput
                                              country={"us"}
                                              value={passenger.phoneNumber}
                                              onChange={(
                                                value,
                                                countryData
                                              ) => {
                                                const updated = [...passengers];
                                                updated[index].phoneNumber =
                                                  value;
                                                setPhoneCountryCode(
                                                  countryData.dialCode || "+1"
                                                );
                                                setPassengers(updated);
                                              }}
                                              inputProps={{
                                                required: true,
                                                name: "phoneNumber",
                                              }}
                                              disabled={!isValidated}
                                            />
                                            <div className="checkbox-wrapper">
                                              <input
                                                type="checkbox"
                                                id={`useContactPhone-${index}`}
                                                checked={
                                                  passenger.useContactPhone
                                                }
                                                onChange={(e) => {
                                                  const updated = [
                                                    ...passengers,
                                                  ];
                                                  updated[
                                                    index
                                                  ].useContactPhone =
                                                    e.target.checked;
                                                  if (e.target.checked) {
                                                    updated[index].phoneNumber =
                                                      mainContactNumber;
                                                  }
                                                  setPassengers(updated);
                                                }}
                                              />
                                              <label
                                                htmlFor={`useContactPhone-${index}`}
                                              >
                                                Use primary contact number
                                              </label>
                                            </div>
                                            {showPhoneNumberError && (
                                              <p className="ErrorMsg">
                                                Please enter your mobile number
                                              </p>
                                            )}
                                            <div className="noteWrap">
                                              <p>
                                                We ask for your mobile number so
                                                we can call or text you about
                                                changes to your itinerary, or
                                                provide helpful information
                                                about your trip.
                                              </p>
                                            </div>
                                          </div>
                                        </li>
                                        <li className="third"></li>
                                      </ul>

                                      <div
                                        className="accordion"
                                        id="accordionExample"
                                      >
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <div
                                              className="accordion-button"
                                              disabled={
                                                !isValidated && index !== 0
                                              }
                                            >
                                              <h3>Additional Information</h3>
                                            </div>
                                          </h2>
                                          <div className="accordion-body show">
                                            <ul className="formList">
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Assistance</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={
                                                        passenger.preferences
                                                          ?.assistance ||
                                                        "No Preference"
                                                      }
                                                      onChange={(e) => {
                                                        const updated = [
                                                          ...passengers,
                                                        ];
                                                        updated[
                                                          index
                                                        ].preferences.assistance =
                                                          e.target.value;
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Deaf">
                                                        Deaf
                                                      </option>
                                                      <option value="Blind">
                                                        Blind
                                                      </option>
                                                      <option value="Wheelchair">
                                                        Wheelchair
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Seat Preference</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={
                                                        passenger.preferences
                                                          ?.seatPreference ||
                                                        "No Preference"
                                                      }
                                                      onChange={(e) => {
                                                        const updated = [
                                                          ...passengers,
                                                        ];
                                                        updated[
                                                          index
                                                        ].preferences.seatPreference =
                                                          e.target.value;
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Window">
                                                        Window
                                                      </option>
                                                      <option value="Aisle">
                                                        Aisle
                                                      </option>
                                                      <option value="Right">
                                                        Right
                                                      </option>
                                                      <option value="Left">
                                                        Left
                                                      </option>
                                                      <option value="Front">
                                                        Front
                                                      </option>
                                                      <option value="Tail">
                                                        Tail
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>Meal Preference</label>
                                                  <div className="selectWrap">
                                                    <select
                                                      defaultValue="No Preference"
                                                      value={
                                                        passenger.meal?.code ||
                                                        "No Preference"
                                                      }
                                                      onChange={(e) => {
                                                        const updated = [
                                                          ...passengers,
                                                        ];
                                                        updated[index].meal = {
                                                          code: e.target.value,
                                                          description:
                                                            e.target.value,
                                                        };
                                                        setPassengers(updated);
                                                      }}
                                                    >
                                                      <option value="No Preference">
                                                        No Preference
                                                      </option>
                                                      <option value="Kosher">
                                                        Kosher
                                                      </option>
                                                      <option value="Halal">
                                                        Halal
                                                      </option>
                                                      <option value="Low cholesterol">
                                                        Low cholesterol
                                                      </option>
                                                      <option value="Low Sodium">
                                                        Low Sodium
                                                      </option>
                                                      <option value="Vegan">
                                                        Vegan
                                                      </option>
                                                      <option value="Vegetarian">
                                                        Vegetarian
                                                      </option>
                                                      <option value="Baby food">
                                                        Baby food
                                                      </option>
                                                      <option value="Child">
                                                        Child
                                                      </option>
                                                      <option value="Diabetic">
                                                        Diabetic
                                                      </option>
                                                      <option value="Gluten free">
                                                        Gluten free
                                                      </option>
                                                      <option value="Hindu">
                                                        Hindu
                                                      </option>
                                                      <option value="Sea Food">
                                                        Sea Food
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              </li>
                                              <li className="half">
                                                <div className="inputField">
                                                  <label>
                                                    Frequent Flyer Number
                                                  </label>
                                                  <input
                                                    type="text"
                                                    value={
                                                      passenger.preferences
                                                        ?.frequentFlyerNumber
                                                    }
                                                    onChange={(e) => {
                                                      const updated = [
                                                        ...passengers,
                                                      ];
                                                      updated[
                                                        index
                                                      ].preferences.frequentFlyerNumber =
                                                        e.target.value;
                                                      setPassengers(updated);
                                                    }}
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="btmNoteWrap">
                                        <div className="icoWrap">
                                          <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M11.2038 7.88915V11.8361M11.2038 14.7963V14.8062M20.0844 10.8494C20.0844 15.754 16.1085 19.73 11.2038 19.73C6.29922 19.73 2.32324 15.754 2.32324 10.8494C2.32324 5.94473 6.29922 1.96875 11.2038 1.96875C16.1085 1.96875 20.0844 5.94473 20.0844 10.8494Z"
                                              stroke="#868E96"
                                              strokeWidth="2.9602"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </div>
                                        <div className="dataWrap">
                                          <h2>
                                            Cabin or carry-on baggage
                                            information
                                          </h2>
                                          <p>
                                            1 cabin baggage that you can take
                                            for your whole trip.
                                          </p>
                                        </div>
                                      </div>
                                      <div
                                        className="addPassengerContentWrap"
                                        style={{ display: "none" }}
                                      >
                                        <form>
                                          <ul className="formList">
                                            <li className="third">
                                              <div className="inputField">
                                                <label>
                                                  First and Middle Name
                                                </label>
                                                <input
                                                  placeholder="e.g. John Doe"
                                                  value={firstName}
                                                  onChange={(e) =>
                                                    setFirstName(e.target.value)
                                                  }
                                                />
                                              </div>
                                            </li>
                                            <li className="third">
                                              <div className="inputField">
                                                <label>Surname</label>
                                                <input
                                                  placeholder="e.g. Bobby"
                                                  value={lastName}
                                                  onChange={(e) =>
                                                    setLastName(e.target.value)
                                                  }
                                                />
                                              </div>
                                            </li>
                                            <li className="third pad0">
                                              <ul className="subFrmList">
                                                <li className="half">
                                                  <div className="inputField">
                                                    <label>Nationality</label>
                                                    <div className="selectWrap">
                                                      <select
                                                        value={nationality}
                                                        onChange={(e) =>
                                                          setNantionality(
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        <option>US</option>
                                                        <option>Indian</option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li className="half">
                                                  <div className="inputField">
                                                    <label>Gender</label>
                                                    <div className="selectWrap">
                                                      <select
                                                        value={gender}
                                                        onChange={(e) =>
                                                          setGender(
                                                            e.target.value
                                                          )
                                                        }
                                                      >
                                                        <option>Male</option>
                                                        <option>Female</option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                </li>
                                              </ul>
                                            </li>
                                            <li className="third">
                                              <div className="inputField">
                                                <label>Date of birth</label>
                                                <div className="datePickerWrap">
                                                  <input
                                                    placeholder="dd/mm/yyyy"
                                                    id="datepicker"
                                                    type="text"
                                                    value={dateOfBirth}
                                                    onChange={(e) =>
                                                      setDateOfBirth(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </li>
                                            <li className="third">
                                              <div className="inputField">
                                                <label>Passport number</label>
                                                <input
                                                  placeholder="Passport number..."
                                                  value={passportNumber}
                                                  onChange={(e) =>
                                                    setPassportNumber(
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </div>
                                            </li>
                                            <li className="third noExpirationWrap">
                                              <div className="inputField">
                                                <label>
                                                  Passport expiration date
                                                </label>
                                                <div className="datePickerWrap">
                                                  <input
                                                    placeholder="dd/mm/yyyy"
                                                    id="datepicker"
                                                    type="text"
                                                    value={passportExpDate}
                                                    onChange={(e) =>
                                                      setPassportExpDate(
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div className="checkBoxWrap">
                                                  <input
                                                    type="checkbox"
                                                    id="NoExpiration"
                                                  />
                                                  <label for="NoExpiration">
                                                    No expiration
                                                  </label>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </form>
                                      </div>
                                      <div
                                        className="AddPassengerCtaWrap"
                                        style={{ display: "none" }}
                                      >
                                        <button
                                          type="button"
                                          className="btn"
                                          id="addPassengerButton"
                                        >
                                          <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M21.1399 12.4202H12.4632V21.0969H8.83877V12.4202H0.16208V8.7958H8.83877V0.0971406H12.4632V8.7958H21.1399V12.4202Z"
                                              fill="#003DF6"
                                            />
                                          </svg>
                                          Add passenger
                                        </button>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="rightPannelWrap mobRightPannelWrap">
                  <div className="itemWrap">
                    <div className="imgWrap">
                      <img src={saleImg} className="img-fluid" alt="" />
                    </div>
                    <div className="dataWrap">
                      <h2>We’ve found you a great deal!</h2>
                      <p>
                        Get more, spend less with up to $575 off when you book
                        your flight + stay together,
                      </p>
                      <a href="#">Shop flight</a>
                    </div>
                  </div>
                  <div className="itemWrap">
                    <div className="topTTl">
                      <h2>Tap into the world of travel</h2>
                    </div>
                    <div className="imgWrap">
                      <img src={QRImg} className="img-fluid" alt="" />
                    </div>
                    <div className="dataWrap">
                      <p>
                        Scan the QR code with your device camera and download
                        our app
                      </p>
                    </div>
                  </div>
                  <div className="itemWrap">
                    <div className="imgWrap">
                      <img src={giftImg} className="img-fluid" alt="" />
                    </div>
                    <div className="dataWrap">
                      <h2>Log-in and get exclusive discounts!</h2>
                      <p>
                        Log in and Unlock all the exclusive offers and use
                        wallet etc
                      </p>
                      <a href="#">Login/Create Account</a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="btmFlightListWrapFixed">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="totalAmtWrap">
                  <h4>
                    {" "}
                    Total Amount :
                    <span>
                      {" "}
                      {preferredCurrency}{" "}
                      {Math.round(convertedTotalPrice).toFixed(2)}{" "}
                    </span>
                  </h4>
                  <div className="rightCtasWrap">
                    <button className="btn btnCancel">Cancel</button>
                    {/* <button type="button" onClick={makePayment} className="btn">Pay</button> */}
                    <button
                      className="btn"
                      onClick={() => saveFlightBookingDetails()}
                      disabled={!isValidated}
                    >
                      Procced To Book
                      <svg
                        width="6"
                        height="16"
                        viewBox="0 0 8 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906"
                          stroke="white"
                          strokeWidth="1.80952"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default FlightReservationTwo;
